export enum MeasurementType {
    Depth = 0,
    Velocity = 1,
}